function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "has4Cols", "has2Cols", "wrapperTag", "itemTag"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import { bool, elementType, node, string } from "prop-types";
import classNamesMaker from "classnames";
import styles from "./elementGrid.module.css";
export var ElementGrid = function ElementGrid(props) {
  var children = props.children,
    className = props.className,
    _props$has4Cols = props.has4Cols,
    has4Cols = _props$has4Cols === void 0 ? false : _props$has4Cols,
    _props$has2Cols = props.has2Cols,
    has2Cols = _props$has2Cols === void 0 ? false : _props$has2Cols,
    _props$wrapperTag = props.wrapperTag,
    WrapperTag = _props$wrapperTag === void 0 ? "ul" : _props$wrapperTag,
    _props$itemTag = props.itemTag,
    ItemTag = _props$itemTag === void 0 ? "li" : _props$itemTag,
    restProps = _objectWithoutProperties(props, _excluded);
  var customClassNames = classNamesMaker(styles["jds-ElementGrid"], _defineProperty({}, styles["jds-ElementGrid--4Cols"], has4Cols), _defineProperty({}, styles["jds-ElementGrid--2Cols"], has2Cols), className);
  return /*#__PURE__*/React.createElement(WrapperTag, _extends({
    className: customClassNames
  }, restProps), React.Children.map(React.Children.toArray(children), function (child) {
    return /*#__PURE__*/React.createElement(ItemTag, {
      key: child.key
    }, child);
  }));
};
ElementGrid.propTypes = {
  children: node.isRequired,
  className: string,
  has4Cols: bool,
  has2Cols: bool,
  wrapperTag: elementType,
  itemTag: elementType
};